import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonService } from '../Common/common.service';
import { ConfigurationService } from '../Configuration/configuration.service';
import { Sa800partnershipinfoService } from '../modules/sa800main/sa800partnershipinfo.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  response: any;

  constructor(private http: HttpClient, private oauthService: OAuthService,
    private Sa800Service: Sa800partnershipinfoService, private configurationService: ConfigurationService, private commonService: CommonService) { }
  async Login() {
    debugger
    var Session_Object = JSON.parse(localStorage.getItem('id_token_claims_obj'));
    this.Sa800Service.GetMasterUID(Session_Object.emails[0]).subscribe(data => {
      this.response = data;
      if (this.response?.length > 0) {
        var Email = Session_Object.emails[0]?.toLowerCase();
        var UserId = this.response[0].UserLoginID
        localStorage.setItem("LatestUserLoginID", (UserId)?.toString())
       this.http.get<any>( "/Authenticate?Email=" + Email + "&UserId=" + UserId).subscribe(async (data: any) => {
       //this.http.get<any>("https://localhost:44369" + "/Authenticate?Email=" + Email + "&UserId=" + UserId).subscribe(async (data: any) => {
          if (data?.message == "User is Authorized.") {
            this.commonService.setShowLayout(true)
            localStorage.setItem('UserEmail', Email)
          } else if (data?.message == "User is Unauthorized.") {
            window.location.href = "/MultiFactorAuthentication"
          } else if (data?.message == "Proceed to log out.") {
            await this.LogOut(UserId)
          }
        })
      }
      else {
        this.oauthService.logOut();
        localStorage.clear();
      }  //commented by LP 30 03 2022  UNCOMENTED AFTER LLICENSE GET COMPLETED
    });
  }
  async LogOut(UserId: number) {
    try {
      await this.http.delete(this.configurationService.getURL() + "/remove-multi-factor-authentication-session?UserId=" + UserId).toPromise()
      setTimeout(() => {
        this.oauthService.logOut()
        sessionStorage.clear()
        localStorage.clear()
      },1000)
      //window.location.reload()

      //this.currentUserSubject.next(new UserRegistrationModel())
      //this.currentLicenseSubject.next(new UserLicenceModel())
    } catch (error) {
      console.error("Logout failed", error);
    }
  }
}
